export enum RateStatus {
  Full = "full",
  Half = "half",
  Void = "void",
}
